import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { MENU_TITLE_DISH_COUNTS_QUERY } from '../graphql/queries'
import { FETCH_MENU_TITLE_DISH_COUNTS } from '../redux/action-types'

const useMenuTitleDishCountsLazyQuery = () => {
  const dispatch = useDispatch()

  const {
    menuTitleDishCountsError: error,
    menuTitleDishCountsLoading: isLoading,
    menuTitleDishCounts: data,
  } = useSelector(store => store.menuTitles)

  const fetch = useCallback(
    filters =>
      apolloService.query({
        query: MENU_TITLE_DISH_COUNTS_QUERY,
        variables: {
          filters,
        },
        dispatch,
        action: FETCH_MENU_TITLE_DISH_COUNTS,
      }),
    [dispatch],
  )

  return [fetch, { isLoading, error, data }]
}

export default useMenuTitleDishCountsLazyQuery
